<!--
 * @Author: your name
 * @Date: 2021-06-30 22:20:14
 * @LastEditTime: 2021-09-14 16:04:55
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /b_c_i18n/src/App.vue
-->
<template>
  <div id="app">
    <!-- 头部 -->
    <Header
      v-if="!$route.meta.hideHeader"
      class="sticky-header-wrapper"
      :show-search="$route.meta.showSearch"
      :is-support-jump="!isStoreFont"
    />
    <div class="view">
      <router-view></router-view>
    </div>
    <!-- 尾部 -->
    <Footer v-if="$route.meta.showFooter" :is-support-jump="!isStoreFont" />
  </div>
</template>

<script>
import config from './config/index'
import addressMonitor from './utils/addressMonitor'
import Header from '@/components/Header'
import Footer from '@/components/Footer'

import { login_callback_logs_fun, login_common_logs_fun } from '@/const/logs'
import { GET_URL_HOST } from '@/utils/tools'
import { delLocalStorage, getLocalStorage, setLocalStorage } from '@/utils/localStorage'
import { setSessionStorage, delSessionStorage } from '@/utils/sessionStorage'
import passportMonitor from './utils/passportMonitor'
import passport from './utils/passport'
import { mapActions, mapMutations, mapState } from 'vuex'
import passportH5 from './utils/passportH5'
import emitter from './utils/emitter'
import GoogleLogUtil from '@/utils/googleLogUtil'
import swRegister from '@/utils/sw-register'
import storeFont from './utils/storefont'
import { getUrlParams } from './utils/routerUrlTransform'
// 提供util判断是否为H5
const isH5 = document.body.clientWidth <= 768

// 注册 | 注销 ServiceWorker
swRegister()
// swUnregister()

export default {
  components: {
    // eslint-disable-next-line vue/no-reserved-component-names
    Header,
    // eslint-disable-next-line vue/no-reserved-component-names
    Footer,
  },
  data() {
    return {
      hasRegisterPassportH5: false,
    }
  },
  computed: {
    ...mapState({
      isH5: ({ common }) => common.isH5,
    }),
    isLogin() {
      return getLocalStorage('isLogin')
    },
    isStoreFont() {
      if (storeFont.isStoreFont() && storeFont.getStoreFontCityId()) {
        setSessionStorage('cityId', storeFont.getStoreFontCityId())
      }
      if (storeFont.isStoreFont()) {
        window?.sessionStorage?.setItem('promotionChannel', storeFont.getPromotionChannel())
      }
      return storeFont.isStoreFont()
    },
  },
  watch: {
    $route: {
      handler(to, from) {
        if (!to.query?.pl) {
          storeFont.watchQueryChange(to.query)
        }
        addressMonitor.watchQueryChange(to.query)

        // hasPathChanged fromRootPath 两句前置判断很重要
        // 目前的路由配置方式，导致from.path为根路径会触发很多次
        const hasPathChanged = to.path !== from.path
        const fromRootPath = from.path === '/'
        if (!fromRootPath && hasPathChanged) {
          this._checkLoginAndPosition()
        }
      },
      deep: true,
    },
  },
  async created() {
    if (this.isLogin) {
      await this.getInit()
    }
  },
  mounted() {
    this.sourceLog()
    this.registerPassport()
    if (config.env.isDev) {
      window.$store = this.$store
    }
    this.seoLog()
  },
  methods: {
    ...mapActions('common', ['getSidebar', 'getToken', 'getCityList']),
    ...mapMutations('common', ['setIsLogin']),
    async getInit() {
      await this.getCityList()
    },

    sourceLog() {
      try {
        const rsc_source = GoogleLogUtil.getGoogleSource()
        if (rsc_source) {
          const queryInfo = GoogleLogUtil.getQueryInfo()

          this.$trackEvent({
            eventId: 'sailing_c_x_source_channel_sw',
            eventLabel: '用户来源渠道曝光',
            attrs: {
              channel: window.location.href,
              referrer: document?.referrer,
              ...queryInfo,
            },
          })
          GoogleLogUtil.setGclid()
        } else {
          GoogleLogUtil.delGclid()
        }

        this.$trackEvent({
          eventId: 'sailing_c_x_entry_sw',
          eventLabel: '全局入口来源埋点',
          attrs: {
            referrer: document?.referrer,
            host: GET_URL_HOST(document?.referrer),
          },
        })
      } catch (err) {}
    },
    seoLog() {
      const pageLink = window.location.href
      const params = getUrlParams()
      const seoChannel = params?.channel
      setSessionStorage('pub_channel_type', seoChannel || '')
      try {
        this.$trackEvent({
          eventId: 'tech_seo_channel_sw',
          eventLabel: 'seo引流渠道统计埋点',
          attrs: {
            channel: seoChannel,
            page_link: pageLink,
          },
        })
      } catch (error) {}
    },
    // 登录结果埋点
    add_login_callback_log() {
      login_callback_logs_fun()
      this.$utils.googleGTM('sailing_c_x_login_callback_ck')
    },

    _checkLoginAndPosition() {
      const hasRedirect = this._checkPositionAndRedirect()
      if (!hasRedirect) {
        this._checkUserInfo()
      }
    },
    _needLoginInfo(routeName) {
      const notNeedLoginInfoRouteName = [
        'address',
        'feed',
        'store',
        'search',
        'efocate',
        'entregaordershare',
      ]
      return !notNeedLoginInfoRouteName.includes(routeName)
    },
    _needPositionInfo(routeName) {
      const notNeedPositionInfoRouteName = [
        'address',
        'store',
        'bill',
        'order',
        'entregaordershare',
      ]
      return !notNeedPositionInfoRouteName.includes(routeName)
    },
    _checkPositionAndRedirect() {
      addressMonitor.flush()
      const addressInfo = addressMonitor.get()

      const hasPositionInfo = addressInfo?.displayName
      setLocalStorage('poiId', addressInfo?.poiId)
      setLocalStorage('poiCityId', addressInfo?.poiCityId || addressInfo?.cityId)
      const name = this.$route?.name
      const needPosition = this._needPositionInfo(name)
      if (needPosition && !hasPositionInfo) {
        this.$router.push('/address/')
        return true
      }

      // 如果地址页有位置信息，回调首页
      const addressPathList = ['address']
      const isAddressPath = addressPathList.includes(name)
      if (isAddressPath && hasPositionInfo && !this.isStoreFont) {
        this.$router.push('/feed/')
        return true
      }

      return false
    },

    _checkUserInfo() {
      const name = this.$route?.name
      const needLogin = this._needLoginInfo(name)
      const isLogin = getLocalStorage('isLogin')
      if (needLogin && !isLogin) {
        passportMonitor.login()
      }
    },
    _clearLoginInfo() {
      delLocalStorage('isLogin')
      delLocalStorage('lastPoiAid')
      delLocalStorage('userInfo')
      delLocalStorage('ticket')
      delLocalStorage('uid')
      delSessionStorage('afterLogin')
      delSessionStorage('promotionChannel')
      delSessionStorage('cityId')
    },
    _initLoginInfo() {
      setLocalStorage('isLogin', true)
      setSessionStorage('afterLogin', true)
      this.getSidebar()
      // getToken中能获取ticket和uid
      this.getToken()
      this.setIsLogin(true)
    },
    _initH5LoginInfo(res) {
      const { ticket = '', uid = '' } = res || {}
      setLocalStorage('isLogin', true)
      setLocalStorage('ticket', ticket)
      setLocalStorage('uid', uid)
      setSessionStorage('afterLogin', true)

      this.getSidebar()
      this.setIsLogin(true)
    },
    // _setLogoutUrl(payload) {
    //   let signOutNoBackFeed = this.$route?.meta?.signOutNoBackFeed
    //   let url = ''
    //   if (!signOutNoBackFeed) {
    //     let location = window.location;
    //     let n = location.pathname.indexOf('/food/');
    //     n != -1 && (url = `${location.origin}${location.pathname.substring(0, n)}/food/feed`);
    //   }
    //   url && (payload.url = url)
    // },
    registerPassport() {
      passportMonitor.registerBeforeLogin(() => {
        // 唤起登录埋点
        login_common_logs_fun()
        this._clearLoginInfo()
        if (this.isH5) {
          /** @desc 增加1s loading **/
          const load = this.$rLoading()
          setTimeout(() => {
            load.close()
          }, 1000)
        }
        console.log('=========== before login ===========')
      })
      passportMonitor.registerAfterLogin(async res => {
        if (isH5) {
          /** @desc 增加1s loading **/
          const load = this.$rLoading()
          await this._initH5LoginInfo(res)
          this.add_login_callback_log()
          location.reload()
          setTimeout(() => {
            load.close()
          }, 1000)
        } else {
          this._initLoginInfo()
          this.add_login_callback_log()
        }
        console.log('=========== after login ===========', res)
      })

      passportMonitor.registerBeforeLogout(() => {
        // this._setLogoutUrl(payload)
        this._clearLoginInfo()
        console.log('=========== before logout ===========')
      })

      passportMonitor.registerAfterLogout(() => {
        console.log('=========== after logout ===========')
        if (isH5) {
          location.reload()
        } else {
          // PC的登录方式，会自动刷新
        }
      })

      passportMonitor.registerLogin(() => {
        if (isH5) {
          if (!this.hasRegisterPassportH5) {
            this.hasRegisterPassportH5 = true

            emitter.on('h5-login-err', err => {
              console.log('=========== h5-login-err ===========', err)
              this.hasRegisterPassportH5 = false
            })
            passportH5.login()
          }
        } else {
          passport.login()
        }
      })
      passportMonitor.registerLogout(() => {
        if (isH5) {
          passportH5.logout()
        } else {
          passport.logout()
        }
      })
      passportMonitor.registerLoaded(() => {
        this._checkLoginAndPosition()
      })
    },
  },
}
</script>

<style lang="scss">
body,
html {
  background: #f5f5f7;
  // https://stackoverflow.com/questions/9471286/window-scrollfunction-not-working-on-firefox
  // fix: 解决 firefox window.scrollTo 失效的问题
  scroll-behaviour: smooth;
}

.view {
  min-height: 80vh;
}

.stop-scrolling {
  height: 100%;
  overflow: hidden;
}

// 只在pc 头部吸顶
.sticky-header-wrapper {
  position: sticky;
  top: 0;
  z-index: 10;
}

@media screen and (max-width: 768px) {
  .sticky-header-wrapper {
    position: unset;
    top: 0;
    z-index: 10;
  }
}
</style>
